import type { HttpValidationError } from "@/core/lib/api-errors";

import { getFaro } from "./faro";

const MAX_LISTED_ERRORS = 10;

// faro event attributes must be strings
type ValidationErrorEvent = Record<
  "method" | "path" | "error_count" | "errors",
  string
>;

/**
 * Where a pydantic 422 failed, for telemetry. The rejected `input` is left out:
 * it echoes what the user typed, and a body-level error carries the whole request.
 */
export function buildValidationErrorEvent(
  request: Request,
  data: HttpValidationError,
): ValidationErrorEvent {
  const detail = data.detail ?? [];
  return {
    method: request.method,
    path: new URL(request.url).pathname,
    error_count: String(detail.length),
    errors: detail
      .slice(0, MAX_LISTED_ERRORS)
      .map((error) => `${error.loc.join(".")}:${error.type}`)
      .join("; "),
  };
}

export function reportValidationError(
  request: Request,
  data: HttpValidationError,
): void {
  getFaro()?.api.pushEvent(
    "api.validation_error",
    buildValidationErrorEvent(request, data),
  );
}
